import React from 'react'
import {useStore} from '../Store/useStore'

function JournalLink({url, content}) {
    let target = '_self';

    if (url.indexOf('https://') === 0) {
        target = '_blank';
    }

    return (
        <a href={url} target={target}>
            {content}
        </a>
    );
}

const Journal = ({resultItem}) => {
    const translations = useStore((state) => state.translations)

    /**
     * Truncate text when length > 142 characters
     * @returns {*|string}
     */
    const getDescriptionText = () => {
        if(resultItem.eventDescription?.length > 142) {
            return resultItem.eventDescription.substr(0, 142)  + "\u2026";
        }
        return resultItem.eventDescription;
    }

    return (
        <div className="journal-list__item">
            <div className="journal-list__item--content">
                <JournalLink url={resultItem.targetUri} content={<img src={resultItem.imageUri} loading="lazy"/>}/>
                <h4 className="journal-list__item-headline">
                    <JournalLink url={resultItem.targetUri} content={resultItem.eventName}/>
                </h4>
                <div className="journal-list__item-description">
                    {resultItem.locationCity ? <><b>Ort:</b> {resultItem.locationCity}<br/></> : null}
                    <b>{translations.date}:</b> {resultItem.date} <br/>
                    <b>{translations.eventStart}:</b> {resultItem.eventStart} Uhr <br/>
                    <b>{translations.eventEnd}:</b> {resultItem.eventEnd} Uhr <br/>
                    <b>{translations.eventCapacity}:</b> {resultItem.eventCapacity} <br/>
                    <p>{getDescriptionText()}</p>
                </div>
            </div>
            <div className="journal-list__item-actions">
                <JournalLink url={resultItem.targetUri} content={translations.button}/>
            </div>
        </div>
    )
}

export default Journal
